import React, { useEffect, useState } from "react"
import BasicTableComponent, { NumberRangeColumnFilter, SelectColumnFilter, DateRangeColumnFilter, formatDateTime } from "../../components/basic.table"
import { fetchAndSetData } from "../../api/Axios"

const CharacterList = ({filter}) => {
    const columns =  [{
        Header: "Minecraft Name",
        accessor: "player_name"
    }, {
        Header: "Name",
        accessor: "name"
    }, {
        Header: "Geschlecht",
        accessor: "geschlecht",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Alter",
        accessor: "alter",
        Filter: SelectColumnFilter,
        filter: 'includes',
    }, {
        Header: "Aussehen",
        accessor: "aussehen"
    },{
        Header: "Erstellt am",
        accessor: (row, _) => row.created * 1000,
        Cell: ({ value }) => formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    },{
        Header: "Sekunden bis zur Löschung",
        accessor: "delete_in",
        Filter: NumberRangeColumnFilter,
        filter: 'between'
    },{
        Header: "Wird gelöscht am",
        accessor: (row, _) => (Math.floor(Date.now() / 1000) + parseInt(row.delete_in)) * 1000,
        Cell: ({ value }) => formatDateTime(value),
        Filter: DateRangeColumnFilter,
        filter: 'dateBetween',
    }]

    const [characters, setCharacters] = useState([])
    useEffect(() => {
        fetchAndSetData("/api/characters" + (filter === undefined ? "" : "/" + filter), "Charaktere konnten nicht geladen werden.", setCharacters)
    }, [filter])

    return (
        <div>
            <BasicTableComponent columns={columns} data={characters} editUrlPart="character" />
        </div>
    )
}
   
export default CharacterList